import styleSelectOption from './select-option.shadow.less';

class SelectOption extends HTMLElement {
    constructor(){
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.applyStyle(styleSelectOption);

        this.init();
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        const label = document.createElement('label');
        // 結構範例
        // <label class="check-wrapper radio">選項文字
        //     <input type="radio" name="cross_site_enable" value="1" checked>
        //     <span class="checkmark"></span>
        // </label>
        label.innerHTML =
        `<span class="text"></span>
        <input />
        <span class="checkmark"></span>`;

        this.root.appendChild(label);
    }

    // *** 以下四種內建的生命週期方法，都是 Callback 結尾 *** //

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    connectedCallback(){

        const input = this.root.querySelector('input');

        input.addEventListener('change', (e) => {

            const target = e.target;

            this.dispatchCustomEvent('select-option-change', {
                name: target.name,
                value: target.value,
                checked: target.checked,
            });
        });
    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    disconnectedCallback(){

    }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // 即使元件尚未加入 DOM 依會監聽屬性變化並觸發
    attributeChangedCallback(name, oldValue, newValue){
        // 以下屬性變動除了改變 input 屬性值，也會影響 :host 套用的 CSS 樣式
        const input = this.root.querySelector('input');

        if(name === 'type'){
            input.type = newValue;
        }

        if(name === 'name'){
            input.name = newValue;
        }

        if(name === 'disabled'){
            // 除了 'disabled' 字串以外的值，都視為 enabled
            // const label = this.root.querySelector('label');
            if(newValue === 'disabled'){
                // this.root.
                // label.classList.add('disabled');
                input.disabled = true;
            } else {
                // label.classList.remove('disabled');
                input.disabled = false;
            }
        }

        if(name === 'checked'){
            // 除了 'checked' 字串以外的值，都視為 uncheck
            if(newValue === 'checked'){
                input.checked = true;
            } else {
                input.checked = false;
            }
            // 需觸發一次 change event，向外層傳遞
            this.dispatchCustomEvent('select-option-change', {
                name: input.name,
                value: input.value,
                checked: input.checked,
            });
        }
    }

    // === 監聽的屬性值 === //
    static get observedAttributes() {
        // 注意 type 的轉換並不安全，所以 type 要在一開始就設定，且避免變動
        return [
            'type', 'name', // 在建立時必要的屬性
            'disabled', 'checked' // optional
        ];
    }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // 很少用，一般可略過
    // adoptedCallback(){

    // }

    // *** 以下為自訂方法 *** //

    // seeter 從外部接收資料
    // 當資料改變時可做相應的處理，例如更新內容等
    set setData(data = null){
        // 必填 name, value
        // 選填 checked (Boolean), text
        if(data){
            this.render(data);
        }
    }

    // === 根據資料產生內容 === //
    render(data){

        const value = data.value;

        const input = this.root.querySelector('input');

        // 在元件本身額外紀錄值，提供外層進行 filter 操作
        this.setAttribute('data-value', value);

        input.value = value;

        if(data.checked){
            input.checked = true;
        }

        // 如果沒有傳入 text，預設用 value 作為選項文字
        const text = data.text ?? data.value;

        this.root.querySelector('.text').textContent = text;
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

}

customElements.define('select-option', SelectOption);